import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

export interface RefreshTokenResponse {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private myTokenCache: Observable<RefreshTokenResponse>;
  private myToken: string;
  private myUserId: number;
  private myTokenSubscription: Subscription;
  private stopTimer: Subject<boolean>;

  constructor(
    private router: Router,
    private cookieService: CookieService
  ) { }



  public createTokenHeader(): HttpHeaders {
    let reqOptions = new HttpHeaders().set('Content-Type', 'application/json')
    if (!this.token && this.cookieService.get('token')) {
      this.token = this.cookieService.get('token');
    }
    if(this.token) {
      reqOptions = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', `Bearer ${this.token}`);
    }
    return reqOptions;
  }

  public clear() {
    if (this.myTokenSubscription) {
      this.myTokenSubscription.unsubscribe();
    }
    if (this.stopTimer) {
      this.stopTimer.next(true);
      this.stopTimer = null;
    }
    this.cookieService.delete('token');
    this.myTokenCache = null;
    this.myToken = null;
    this.myUserId = null;
    this.router.navigate(['/login']);
  }

  get tokenStream(): Observable<string> {
    return this.myTokenCache.pipe(map((response: any) => response.token));
  }

  get token(): string {
    return this.myToken;
  }

  set token(token: string) {
    this.myToken = token;
  }

  get userId(): number {
    return this.myUserId;
  }

  set userId(userId: number) {
    this.myUserId = userId;
  }
}
